import { t } from 'i18next';
import { ALL_MODEL_DEFINITIONS } from '../../helpers/MonitorTypeHelpers';

/**
 * Klucz modelu ze statystyk → nazwa na slajdzie. Budujemy mapę z tej samej definicji, co filtry
 * modeli w panelu, więc nowy model wystarczy dodać tam raz.
 *
 * Statystyki oddają model w dwóch postaciach i obie muszą trafiać w tę samą etykietę:
 * `ChatType` z wariantem przeglądarkowym (`AI_MODE_BROWSER`) oraz zwiniętą rodzinę
 * (`AI_MODE`) — tę drugą zwracają zapytania per model i macierz konkurencji.
 */
const MODEL_NAME_KEYS: Record<string, string> = ALL_MODEL_DEFINITIONS.reduce(
  (map, definition) => {
    map[definition.type] = definition.nameKey;
    map[definition.modelKey] = definition.nameKey;
    return map;
  },
  {
    // Rodziny, których nazwa rozjeżdża się z kluczem uprawnienia albo mają własne warianty.
    AI_MODE: 'aiModeName',
    AI_OVERVIEW_BROWSER: 'aiModeName',
    // Patrz `modelIcon`: rodzina `AI_OVERVIEW` z llm-common to NOWE AI Overview, mimo że ten sam
    // klucz w definicjach panelu opisuje uprawnienie starego AI Mode.
    AI_OVERVIEW: 'aiOverviewName',
    GPT_BROWSER: 'gptName',
    GPT_SEARCH: 'gptSearchName',
    GEMINI_BROWSER: 'geminiSearchName',
    PERPLEXITY_BROWSER: 'perplexityName',
  } as Record<string, string>
);

// Po `reduce` — patrz `modelIcon`.
MODEL_NAME_KEYS.AI_OVERVIEW = 'aiOverviewName';

export const modelLabel = (model: string): string => {
  const key = MODEL_NAME_KEYS[model];
  return key ? t(key) : model;
};
